<!-- YourComponent.vue -->
<template>
  <div class="text-container">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TextContainer'
}
</script>

<style scoped>
  .text-container {
    max-width: 794px;
    margin: 0 auto;
  }
</style>
